<template>
  <footer class="the-footer" :class="{ mobile: configStore.isMobileLayout }">
    <div v-if="configStore.isMobileLayout">
      <button type="button" class="cart__button" @mouseup="handleCartClick" @touchend.prevent="handleCartClick">
        <span class="button__box">
          <svg xmlns="http://www.w3.org/2000/svg" width="27.917" height="33.5" viewBox="0 0 27.917 33.5">
            <path
              id="iconmonstr-shopping-bag-4"
              d="M27.125,9.771H21.542V5.583a5.583,5.583,0,0,0-11.167,0V9.771H4.792L2,33.5H29.917ZM11.771,5.583a4.188,4.188,0,0,1,8.375,0V9.771H11.771ZM5.139,30.708,7.273,12.563h3.1v2.094a.7.7,0,1,0,1.4,0V12.563h8.375v2.094a.7.7,0,1,0,1.4,0V12.563h3.1l2.134,18.146H5.139Z"
              transform="translate(-2)"
            />
          </svg>
          <span class="button__qty">{{ cartStore.totalQty }}</span>
        </span>
      </button>

      <!-- GNB 메뉴 -->
      <nav class="app-bar">
        <ul class="app-bar__ul list-style-none">
          <li>
            <button
              type="button"
              class="app-bar__button order"
              @mouseup="handleOrderHistoryClick"
              @touchend.prevent="handleOrderHistoryClick"
            >
              <figure class="app-bar__figure">
                <img src="@/assets/images/icon-order-list.svg" alt="주문목록 아이콘" />
              </figure>
              <span>{{ t('button.order_history') }}</span>
            </button>
          </li>
          <li v-if="menuStore.callMessages.length > 0">
            <button
              type="button"
              class="app-bar__button call"
              @mouseup="handleStaffCallClick"
              @touchend.prevent="handleStaffCallClick"
            >
              <figure class="app-bar__figure">
                <img src="@/assets/images/icon-call.svg" alt="호출 아이콘" />
              </figure>
              <span>{{ t('button.staff_call') }}</span>
            </button>
          </li>
          <li v-if="configStore.usePreOrder">
            <button
              type="button"
              class="app-bar__button cart"
              @mouseup="handlePaymentClick"
              @touchend.prevent="handlePaymentClick"
            >
              <figure class="app-bar__figure" style="height: 26px">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="26"
                  height="26"
                  viewBox="0 0 32 35"
                >
                  <g transform="translate(-0.4 0.131)">
                    <g transform="translate(0.4 -0.131)">
                      <path
                        d="M31.919,18.266c-1.607-1.718-6.026-6.085-7.6-7.633L21.372,12.1l7.7,7.729a1.95,1.95,0,0,1-.621,3.234c-1.278.718-8.828,4.877-10.555,5.829a4.859,4.859,0,0,0-1.365-2.814c-.775-.8-10.107-10.656-12.434-13.259A2.183,2.183,0,0,1,3.606,10.2,2.753,2.753,0,0,1,5.97,8.871a2.526,2.526,0,0,1,2.56,1.755A2.1,2.1,0,0,1,7.5,13.061l2.2,2.346L22.582,8.984a4.582,4.582,0,0,0,1.537-6.52A5.93,5.93,0,0,0,19.2,0C17.234,0,17.887-.023,3.388,6.465A5.1,5.1,0,0,0,0,11.09a5.381,5.381,0,0,0,1.469,3.593c2.359,2.592,12.5,13.269,12.588,13.373a2.033,2.033,0,0,1,.248,2.417,2.653,2.653,0,0,1-2.362,1.28A2.525,2.525,0,0,1,9.383,30a2.025,2.025,0,0,1,1-2.389L8.271,25.375A5.021,5.021,0,0,0,5.995,28.9c-.383,3.185,2.521,5.768,5.972,5.768a6.717,6.717,0,0,0,3.043-.737l15.581-8.59a4.954,4.954,0,0,0,2.466-4.185,4.216,4.216,0,0,0-1.137-2.894M18.214,3.109a2.706,2.706,0,0,1,1.007-.194A2.341,2.341,0,0,1,21.275,4a1.912,1.912,0,0,1-.906,2.762l-8.424,4.172a5.044,5.044,0,0,0-2.4-3.947Zm5.378,14.526-7.98,4.078-1.066-1.128,7.942-4.056,1.1,1.107m-11.5.344,7.851-4.012,1.1,1.109-7.889,4.032-1.066-1.13m14.032,2.194L18.054,24.3l-1.066-1.128,8.029-4.1,1.1,1.108"
                        transform="translate(-0.4 0.132)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </svg>
              </figure>
              <span>{{ t('button.pay') }}</span>
            </button>
          </li>
          <li>
            <button
              type="button"
              class="app-bar__button cart"
              @mouseup="handleCartClick"
              @touchend.prevent="handleCartClick"
            >
              <figure class="app-bar__figure">
                <span class="button__qty">{{ cartStore.totalQty }}</span>
                <img src="@/assets/images/icon-shopping-back-white.svg" alt="쇼핑백 아이콘" />
              </figure>
              <span>{{ t('button.cart') }}</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>

    <div v-else class="the-footer__inner">
      <div class="the-footer__utility">
        <!-- 언어 선택 -->
        <BaseSelectLanguage />

        <!-- 유틸리티 메뉴 -->
        <nav class="utility__menu">
          <ul class="utility__ul list-style-none">
            <li v-if="configStore.config.IsFastOrderUsed">
              <button
                type="button"
                class="utility__button call"
                @mouseup="handleHomeClick"
                @touchend.prevent="handleHomeClick"
              >
                <img src="@/assets/images/icon-home.svg" alt="홈 아이콘" />
                <span>{{ t('button.home') }}</span>
              </button>
            </li>
            <li>
              <button
                type="button"
                class="utility__button order"
                @mouseup="handleOrderHistoryClick"
                @touchend.prevent="handleOrderHistoryClick"
              >
                <img src="@/assets/images/icon-order-list.svg" alt="주문목록 아이콘" />
                <span>{{ t('button.order_history') }}</span>
              </button>
            </li>
            <li v-if="menuStore.callMessages.length > 0 && !configStore.config.IsFastOrderUsed">
              <button
                type="button"
                class="utility__button call"
                @mouseup="handleStaffCallClick"
                @touchend.prevent="handleStaffCallClick"
              >
                <img src="@/assets/images/icon-call.svg" alt="직원 호출 아이콘" />
                <span>{{ t('button.staff_call') }}</span>
              </button>
            </li>
            <li v-if="configStore.config.MobileMenupanCode !== '0002'">
              <button
                type="button"
                class="utility__button mobile"
                @mouseup="handleMobileMenuClick"
                @touchend.prevent="handleMobileMenuClick"
              >
                <img src="@/assets/images/icon-mobile-menu.svg" alt="모바일 메뉴판 아이콘" />
                <span>{{ t('button.mobile_menu') }}</span>
              </button>
            </li>
            <li v-if="configStore.config.IsOriginInformationUsed">
              <button
                type="button"
                class="utility__button origin"
                @mouseup="handleOriginInfoClick"
                @touchend.prevent="handleOriginInfoClick"
              >
                <img src="@/assets/images/icon-origin-information.png" alt="원산지 정보 아이콘" />
                <span>{{ t('button.origin_information') }}</span>
              </button>
            </li>
          </ul>
        </nav>
      </div>
      <div class="the-footer__cart">
        <div class="footer__button">
          <button
            v-if="configStore.usePreOrder"
            type="button"
            class="cart__button outline small"
            @mouseup="handlePaymentClick"
            @touchend.prevent="handlePaymentClick"
          >
            <span class="button__box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="32"
                height="35"
                viewBox="0 0 32 35"
              >
                <path
                  d="M31.919,18.266c-1.607-1.718-6.026-6.085-7.6-7.633L21.372,12.1l7.7,7.729a1.95,1.95,0,0,1-.621,3.234c-1.278.718-8.828,4.877-10.555,5.829a4.859,4.859,0,0,0-1.365-2.814c-.775-.8-10.107-10.656-12.434-13.259A2.183,2.183,0,0,1,3.606,10.2,2.753,2.753,0,0,1,5.97,8.871a2.526,2.526,0,0,1,2.56,1.755A2.1,2.1,0,0,1,7.5,13.061l2.2,2.346L22.582,8.984a4.582,4.582,0,0,0,1.537-6.52A5.93,5.93,0,0,0,19.2,0C17.234,0,17.887-.023,3.388,6.465A5.1,5.1,0,0,0,0,11.09a5.381,5.381,0,0,0,1.469,3.593c2.359,2.592,12.5,13.269,12.588,13.373a2.033,2.033,0,0,1,.248,2.417,2.653,2.653,0,0,1-2.362,1.28A2.525,2.525,0,0,1,9.383,30a2.025,2.025,0,0,1,1-2.389L8.271,25.375A5.021,5.021,0,0,0,5.995,28.9c-.383,3.185,2.521,5.768,5.972,5.768a6.717,6.717,0,0,0,3.043-.737l15.581-8.59a4.954,4.954,0,0,0,2.466-4.185,4.216,4.216,0,0,0-1.137-2.894M18.214,3.109a2.706,2.706,0,0,1,1.007-.194A2.341,2.341,0,0,1,21.275,4a1.912,1.912,0,0,1-.906,2.762l-8.424,4.172a5.044,5.044,0,0,0-2.4-3.947Zm5.378,14.526-7.98,4.078-1.066-1.128,7.942-4.056,1.1,1.107m-11.5.344,7.851-4.012,1.1,1.109-7.889,4.032-1.066-1.13m14.032,2.194L18.054,24.3l-1.066-1.128,8.029-4.1,1.1,1.108"
                  transform="translate(-0.4 0.132)"
                  fill="#fff"
                />
              </svg>
              <span class="button__text">{{ t('button.pay') }}</span>
            </span>
          </button>
          <button
            type="button"
            class="cart__button"
            :class="{ small: configStore.usePreOrder }"
            @mouseup="handleCartClick"
            @touchend.prevent="handleCartClick"
          >
            <span class="button__box">
              <svg xmlns="http://www.w3.org/2000/svg" w idth="27.917" height="33.5" viewBox="0 0 27.917 33.5">
                <path
                  id="iconmonstr-shopping-bag-4"
                  d="M27.125,9.771H21.542V5.583a5.583,5.583,0,0,0-11.167,0V9.771H4.792L2,33.5H29.917ZM11.771,5.583a4.188,4.188,0,0,1,8.375,0V9.771H11.771ZM5.139,30.708,7.273,12.563h3.1v2.094a.7.7,0,1,0,1.4,0V12.563h8.375v2.094a.7.7,0,1,0,1.4,0V12.563h3.1l2.134,18.146H5.139Z"
                  transform="translate(-2)"
                />
              </svg>
              <span class="button__text">{{ t('button.cart') }}</span>
              <span class="button__qty">{{ cartStore.totalQty }}</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
  import { openServiceApp } from '@/api/android';
  import BaseSelectLanguage from '@/components/base/BaseSelectLanguage.vue';
  import MobileMenu from '@/components/MobileMenu.vue';
  import OrderHistory from '@/components/OrderHistory.vue';
  import OriginInformationModal from '@/components/OriginInformationModal.vue';
  import StaffCall from '@/components/StaffCall.vue';
  import { useCartStore } from '@/stores/cart';
  import { useConfigStore } from '@/stores/config';
  import { useMenuStore } from '@/stores/menu';
  import { useModalStore } from '@/stores/modal';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
  const configStore = useConfigStore();
  const cartStore = useCartStore();
  const modalStore = useModalStore();
  const menuStore = useMenuStore();

  /** 패스트오더 서비스 앱 홈으로 돌아가기 */
  const handleHomeClick = () => openServiceApp();
  /** 주문내역 버튼 클릭 */
  const handleOrderHistoryClick = () => modalStore.openFullScreenModal(OrderHistory, {});
  /** 직원호출 버튼 클릭 */
  const handleStaffCallClick = () => modalStore.openFullScreenModal(StaffCall, {});
  /** 모바일메뉴 버튼 클릭 */
  const handleMobileMenuClick = () => modalStore.openFullScreenModal(MobileMenu, {});
  /** 원산지 정보 버튼 클릭 */
  const handleOriginInfoClick = () => modalStore.openFullScreenModal(OriginInformationModal, {});
  /** 결제하기 버튼 클릭 */
  const handlePaymentClick = () => modalStore.openFullScreenModal(OrderHistory, {});
  /** 장바구니 버튼 클릭 */
  const handleCartClick = () => modalStore.openCartModal();
</script>

<style lang="scss" scoped>
  @use '@/assets/scss/variables' as vars;

  .the-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: vars.$base-gradient;
    z-index: 2;
    .the-footer__inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 7.0149vw;
      padding: 0.8955vw 1.1194vw;
      @media (max-width: vars.$lg) {
        height: 80px;
      }
    }
    .the-footer__utility {
      display: flex;
      align-items: center;
      .utility__language {
        position: relative;
        .language__current {
          position: relative;
          display: flex;
          align-items: center;
          width: 5.9701vw;
          .current__text {
            font-size: 1.4925vw;
            font-weight: 400;
            line-height: 2.0896vw;
            color: #fff;
            margin-right: 1.194vw;
            white-space: nowrap;
          }
          // Todo: (Add) CSS 추가
          img {
            width: 1.308vw;
          }
        }

        .language__ul {
          position: absolute;
          bottom: -1.7164vw;
          left: -1.9403vw;
          min-width: 8.9552vw;
          background: #fff;
          border-radius: 0.5224vw;
          border: 0.0746vw solid #707070;
          z-index: 4;
          li {
            position: relative;
            display: flex;
            align-items: center;
            padding: 0 1.3433vw 0 1.8657vw;
            height: 5.2239vw;
          }
          li + li {
            border-top: 0.0746vw solid #707070;
          }
          .current__text {
            font-size: 1.4925vw;
            font-weight: 400;
            line-height: 2.0896vw;
            margin-right: 1.194vw;
            white-space: nowrap;
          }
          // Todo: (Add) CSS 추가
          img {
            width: 1.308vw;
          }
          // Todo: (Add) CSS 추가
        }

        .language__backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: calc(var(--vh, 1vh) * 100);
        }
      }
      .utility__ul {
        display: flex;
        align-items: center;
        & > li + li {
          margin-left: 2.5373vw;
        }
        button {
          padding: 0.7463vw;
        }
      }
      .utility__button {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        margin: 0;
        height: 5.2239vw;
        background: transparent;
        border: none;
        word-break: keep-all;
        @media (max-width: vars.$lg) {
          flex-direction: column;
          img {
            height: 26px;
          }
        }
        & > span {
          font-size: 1.4925vw;
          font-weight: 400;
          color: #fff;
          margin-left: 0.2239vw;
          @media (max-width: vars.$lg) {
            margin-top: 4px;
            margin-left: 0;
          }
        }
      }
      .utility__button.order img {
        width: 2.462vw;
      }
      .utility__button.receipt img {
        width: 2.462vw;
      }
      .utility__button.call img {
        width: 3.231vw;
      }
      .utility__button.mobile img {
        width: 2.154vw;
      }
    }

    .the-footer__cart {
      height: 100%;
      .footer__button {
        display: flex;
        flex-direction: row;
        gap: 0.7463vw;
        height: 100%;
        .cart__button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 31.3433vw;
          height: 100%;
          border-radius: 0.3731vw;
          background: var(--brand-tertiary);
          border: 0.0746vw solid var(--brand-primary);
          @media (max-width: vars.$lg) {
            width: 300px;
          }
          &.small {
            width: 17.9104vw;
            @media (max-width: vars.$md) {
              width: 150px;
            }
          }
          &.outline {
            background: #fff !important;
            border: 0.0746vw solid var(--brand-primary);
            .button__text {
              color: var(--brand-primary);
            }
            svg {
              path {
                fill: var(--brand-primary);
              }
            }
          }
          .button__box {
            position: relative;
            display: flex;
            justify-content: center;
            gap: 0.7463vw;
            align-items: center;
            svg {
              position: relative;
              height: 2.0896vw;
              fill: #fff;
              @media (max-width: vars.$lg) {
                height: 22px;
              }
            }
          }
          .button__text {
            font-size: 2.0896vw;
            font-weight: 500;
            color: #fff;
            @media (max-width: vars.$lg) {
              font-size: 22px;
            }
          }
          .button__qty {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 3.2836vw;
            height: 3.2836vw;
            background: vars.$base-gradient;
            border: 0.0746vw solid var(--brand-primary);
            font-size: 1.8657vw;
            font-weight: 700;
            color: var(--point-color-primary);
            border-radius: 50%;
            padding: 0 0.597vw;
            @media (max-width: vars.$lg) {
              width: 32px;
              height: 32px;
              font-size: 18px;
            }
          }
        }
      }
    }
  }

  // Dark Mode
  .dark-theme,
  .dark-gray-theme {
    .the-footer {
      background: #0a0807;
      box-shadow: none;
    }
    .the-footer__cart {
      .cart__button {
        background: var(--brand-primary) !important;
        border: none;
        .button__box {
          position: relative;
          display: flex;
          align-items: center;
          svg {
            fill: #fff;
          }
        }
        .button__qty {
          background: #951a16 !important;
          box-shadow: none;
          border: none;
        }
      }
    }
  }
  .green-theme {
    .the-footer {
      background: var(--bg-black);
      box-shadow: none;
    }
    .the-footer__cart {
      .cart__button {
        background: var(--brand-primary) !important;
        .button__text {
          color: #fff;
        }
        svg path {
          fill: #fff;
        }
        .button__qty {
          box-shadow: none;
          background: var(--bg-black) !important;
        }
      }
    }
  }

  .blue-theme {
    .the-footer {
      background: #20272b;
      box-shadow: none;
    }
    .the-footer__cart {
      .cart__button {
        background: var(--brand-primary) !important;
        border: none;
        .button__box {
          position: relative;
          display: flex;
          align-items: center;
          svg {
            fill: #fff;
          }
        }
        .button__qty {
          background: var(--bg-black) !important;
          box-shadow: none;
          border: none;
        }
      }
    }
  }

  .light-blue-theme {
    .the-footer {
      background: #2d384e;
      box-shadow: none;
    }
    .the-footer__cart {
      .cart__button {
        background: var(--brand-primary) !important;
        border: none;
        .button__box {
          position: relative;
          display: flex;
          align-items: center;
          svg {
            fill: #fff;
          }
        }
        .button__qty {
          background: var(--bg-black) !important;
          box-shadow: none;
          border: none;
        }
      }
    }
  }

  .dark-gray-theme {
    .the-footer {
      background: #1e1f1d;
      box-shadow: 0px -3px 5px #00000066;
      border: 1px solid #000000;
    }
  }

  .the-footer.mobile {
    .button__qty {
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(2px, -6px);
      line-height: 1;
      background: #20272b;
      box-shadow: none;
      border: none;
      font-size: 12px;
      font-weight: 700;
      color: var(--point-color-primary);
      border-radius: 12px;
      padding: 6px 8px;
    }
    .cart__button {
      position: fixed;
      bottom: 76px;
      right: 16px;
      width: 56px;
      height: 56px;
      background: var(--brand-primary);
      border: none;
      border-radius: 50%;
      svg {
        margin-top: 2px;
        width: 22px;
        fill: #fff;
      }
      .button__box {
        position: relative;
        display: block;
      }
    }
    .app-bar {
      .app-bar__ul {
        display: flex;
        align-items: center;
        li {
          flex: 1 1 0;
        }
      }
      .app-bar__button {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 60px;
        border: none;
        background: #20272b;
        span {
          font-size: 12px;
          text-align: center;
          color: #fff;
          word-break: keep-all;
        }
      }
      .app-bar__figure {
        position: relative;
        margin-bottom: 6px;
        padding: 0 14px;
        img {
          height: 26px;
        }
        .button__qty {
          background: var(--brand-primary);
        }
      }
    }
  }
</style>
